import React, { useState } from "react";
import axios from "../../axios/axios";
import Layout from "./Layout";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const AddServices = () => {
  const [errorMessage, seterrorMessage] = useState("");
  const [file, setFile] = useState(null);

  const onFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const [service, setService] = useState({
    title: "",
    price: "",
    description: "",
    service: "",
  });

  const serviceHandler = (e) => {
    const { name, value } = e.target;
    setService({ ...service, [name]: value });
  };

  const addService = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", service.title);
    formData.append("price", service.price);
    formData.append("description", service.description);
    formData.append("service", service.service);
    if (file) {
      formData.append("file", file);
    }

    try {
      const response = await axios.post("/services", formData);
      const data = response.data;
      if (data) {
        toast.success("Service Added");
        window.location.href = "/all-services";
      }
    } catch (error) {
      seterrorMessage(error.response?.data?.message || "An error occurred");
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };
  return (
    <>
      <Navbar />
      <Layout>
        <div className=" py-5 h-100 bg-light">
          <div className="col-md-7 container">
            <form onSubmit={addService}>
              <h3 className="text-center fw-bold prata-regular mb-4">
                Add Services
              </h3>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
              <div class="mb-3">
                <input
                  onChange={serviceHandler}
                  name="title"
                  value={service.title}
                  type="text"
                  placeholder="Title *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>

              <div class="mb-3">
                <input
                  onChange={serviceHandler}
                  name="price"
                  value={service.price}
                  type="number"
                  placeholder="Price *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>

              <div className="mb-3">
                <input
                  onChange={onFileChange}
                  type="file"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>

              <div class="mb-3">
                <input
                  onChange={serviceHandler}
                  name="description"
                  value={service.description}
                  type="text"
                  placeholder="Description *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>
              <div className="mb-3">
                <select
                  onChange={serviceHandler}
                  name="service"
                  value={service.service}
                  className="form-select w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                >
                  <option value="">Select Service</option>
                  <option value="Color Correction">Color Correction</option>
                  <option value="Culling">Culling</option>
                  <option value="Video Editing">Video Editing</option>
                  <option value="Album Design">Album Design</option>
                  <option value="Real Estate">Real Estate</option>
                  <option value="Retouching">Retouching</option>
                </select>
              </div>

              <button
                type="submit"
                name="submit"
                class="btn bg_maincolor text-light"
              >
                Add Service
              </button>
            </form>
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default AddServices;
